/* eslint-env node es2020 */

/*!
 * Copyright (c) 2022 by DCCS GmbH. All rights reserved.
 */

// eslint-disable-next-line no-undef
__webpack_public_path__ =
    process.env.NODE_ENV === 'production' && window.ams && window.ams.cdnFrontendLoaderUrl
        ? window.ams.cdnFrontendLoaderUrl
        : '/o/ams-osram-frontend-loader/assets/';

require('./bootstrap');

import './helpers/format.js';
import(/* webpackChunkName: "high-contrast-toggle" */ './common/high-contrast-toggle.js');
import(/* webpackChunkName: "local-storage-helper" */ './helpers/localStorageHelper.js');
import initAmspAccountRoles from './components/PermissionMonitor/amsp-account-roles';
import initSemiAccountRoles from './components/PermissionMonitor/semi-account-roles';
import '@vuepic/vue-datepicker/dist/main.css';

if (document.querySelector('[data-lazyload]')) {
    import(/* webpackChunkName: "lazyload" */ './components/lazy-load-source.js')
        .then(module => module.default())
        .catch(error => console.error('An error occurred while loading the component `Lazy Load Source`', error));
}

// Init tooltips automatically for server-rendered tooltip markers
if (document.querySelector('.tooltip, [data-tooltip]')) {
    import(/* webpackChunkName: "tooltip" */ './components/DesignSystem/Tooltip/tooltip-init.js')
        .then(module => {
            if (module.initTooltipsDelegated) {
                module.initTooltipsDelegated(document.body, '.tooltip, [data-tooltip]');
            } else if (module.default) {
                module.default();
            }
        })
        .catch(error => console.error('An error occurred while loading the Tooltip init module', error));
}

if (
    document.querySelector(
        '[id^="fragment-"] a[href^="/"]:not([href^="/en/"]):not([href^="/zh/"]):not([href^="/ja/"]):not([href^="/ko/"]):not([href^="/de/"]):not([href^="/documents/"])'
    )
) {
    import(/* webpackChunkName: "prepend-locale-to-links" */ './components/prepend-locale-to-links.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the prepend locales script!`', error));
}

if (document.querySelector('.main-navigation')) {
    import(/* webpackChunkName: "navigation" */ './components/navigation.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the navigation script!`', error));
}

if (document.querySelector('.main-navigation-searchview')) {
    import(/* webpackChunkName: "navigation" */ './components/quicksearch.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the quicksearch script!`', error));
}

if (document.querySelector('.article-video, .two-column.has-video, .hero.has-video')) {
    import(/* webpackChunkName: "video" */ './components/video.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Video fragment script!`', error));
}
if (document.querySelector('.collapsable')) {
    import(/* webpackChunkName: "collapsable" */ './components/collapsable.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Collapsable fragment script!`', error));
}

if (document.querySelectorAll('[data-tracking="true"]')) {
    import(/* webpackChunkName: "tracking" */ './components/tracking.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Tracking script!`', error));
}

if (!document.querySelector('.ecom-specific')) {
    import(/* webpackChunkName: "leadinfo-datalayer" */ './components/leadinfo-datalayer.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the LeadInfo dataLayer script!', error));
}

if (document.querySelector('.slider-container')) {
    import(/* webpackChunkName: "slider" */ './components/slider.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Slider fragment script!`', error));
}

if (document.getElementById('chat-widget-app')) {
    import(/* webpackChunkName: "ai-chatbot" */ './components/AiChatbot/index')
        .then(module => module.default())
        .catch(error => console.error('An error occurred while trying to load the Ai chatbot module.', error));
}

if (document.querySelector('.dccs-form')) {
    import(/* webpackChunkName: "dccs-form" */ './components/DccsForm/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the component `DCCSForm`', error));
}
localStorage['formsLoaded'] = false;
if (document.querySelector('.contact-form')) {
    import(/* webpackChunkName: "dccs-contact-form" */ './components/DccsForm/contact-form.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the component `Contact form`!', error));
}

if (document.querySelector('.support-form')) {
    import(/* webpackChunkName: "dccs-support-form" */ './components/DccsForm/support-form.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the component `Support form`!', error));
}

if (document.querySelector('#newsletter-form')) {
    import(/* webpackChunkName: "dccs-newsletter-form" */ './components/NewsletterForm/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the component `Newsletter form`!', error));
}

if (document.querySelector('.dccs-form-wrapper')) {
    import(/* webpackChunkName: "dccs-form" */ './components/DccsForm/loading-forms.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the component `DCCSForms loading`', error));
}

if (document.getElementById('app-download-center')) {
    import(/* webpackChunkName: "download-center" */ './components/DownloadCenter/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app DownloadCenter!', error));
}

if (document.querySelector('[data-dynamic-dropdown]')) {
    import(/* webpackChunkName: "download-center" */ './components/DynamicDropdown/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app DynamicDropdown!', error));
}

function isPotentialProductDetailPage() {
    if (typeof window === 'undefined') return false;

    try {
        const pathname = window.location.pathname.toLowerCase();
        if (!pathname.startsWith('/products')) return false;

        const segments = pathname.split('/').filter(Boolean);
        return segments.length > 1;
    } catch {
        return false;
    }
}

if (
    document.querySelector('.breadcrumbs') &&
    !document.querySelector('.product-hero') &&
    !isPotentialProductDetailPage()
) {
    import(/* webpackChunkName: "breadcrumb-updater" */ './setup/breadcrumbUpdater.js')
        .then(module => {
            if (module && module.default) module.default();
        })
        .catch(error => console.error('An error occurred while loading the Breadcrumb updater!', error));
}

if (document.getElementById('app-document-upload')) {
    import(/* webpackChunkName: "document-upload" */ './components/DocumentUpload/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app DocumentUpload!', error));
}

if (document.getElementById('support-form')) {
    import(/* webpackChunkName: "support-form" */ './components/SupportForm/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app SupportForm!', error));
}

if (document.getElementById('compliance-blocked-popup')) {
    import(/* webpackChunkName: "user-compliance-popup" */ './components/UserCompliancePopup/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app UserCompliancePopup!', error));
}

if (document.getElementById('app-product-user-mapping')) {
    import(/* webpackChunkName: "product-user-mapping" */ './components/ProductUserMapping/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app ProductUserMapping!', error));
}

if (document.querySelector('.product-hero')) {
    import(/* webpackChunkName: "product-hero-image-gallery" */ './components/product-hero-image-gallery.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the product-hero-image-gallery module!', error));
}

if (document.querySelector('.product-hero') && !document.querySelector('.slider-container')) {
    import(/* webpackChunkName: "slider" */ './components/slider.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Slider fragment script!`', error));
}

if (document.querySelector('.ecom-specific')) {
    import(/* webpackChunkName: "product-hero-image-gallery" */ './components/ecom-specific.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the product-hero-image-gallery module!', error));
}

if (document.querySelector('#content .breadcrumbs .breadcrumb')) {
    import(/* webpackChunkName: "breadcrumbs" */ './components/breadcrumbs.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the breadcrumbs module!', error));
}

if (document.getElementById('family-page-redirect')) {
    import(/* webpackChunkName: "family-page-redirect" */ './components/family-page-redirect.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app FamilyPageRedirect!', error));
}

if (document.getElementById('app-partner-network')) {
    import(/* webpackChunkName: "partner-network" */ './components/PartnerNetwork/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app PartnerNetwork!', error));
}

if (document.getElementById('ingredient-branding')) {
    import('./components/IngredientBranding/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app IngredientBranding!', error));
}

if (document.querySelector('#wrapper')) {
    import(/* webpackChunkName: "open-graph-image" */ './components/open-graph-image.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the open-graph-image script!', error));
}

// LEGACY STUFF

window.ams = window.ams || {};
window.ams.semiMockCart = true;
window.ams.initToggleOnButtonClick = (buttonId, defaultLabel, newLabel) => {
    import('./legacy/toggle-content-button.js')
        .then(module => {
            module.default(buttonId, defaultLabel, newLabel);
        })
        .catch(error => console.error('An error occurred while loading the component `ToggleContentButton`', error));
};

window.ams.formatDisplayDateHelper = (string, locale) => {
    return import('./helpers/formatDisplayDate.js').then(module => module.default(string, locale));
};

if (
    document.getElementById('app-search-page') ||
    document.querySelector('#app-search-product-list, .app-search-product-list')
) {
    import(/* webpackChunkName: "search" */ './components/Search/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occurred while trying to load the search application.', error));
}

if (document.getElementById('app-ecom-search-page')) {
    import(/* webpackChunkName: "search" */ './components/ECOMSearch/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occurred while trying to load the ecom search application.', error));
}

if (document.getElementById('news-hub-container')) {
    import(/* webpackChunkName: "news-hub" */ './components/NewsHub/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occurred while loading the NewsHub application.', error));
}

if (document.getElementById('account-address')) {
    import(/* webpackChunkName: "account-address" */ './components/AccountAddress/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app AccountAddress!', error));
}

if (document.getElementById('buy-now')) {
    import(/* webpackChunkName: "quote-list" */ './components/BuyNow/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app BuyNow!', error));
}

if (document.getElementById('quote-list')) {
    import(/* webpackChunkName: "quote-list" */ './components/Quote/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app Quote!', error));
}
if (document.getElementById('delivery-list')) {
    import(/* webpackChunkName: "quote-list" */ './components/Delivery/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app Delivery!', error));
}
if (document.getElementById('semi-delivery-list')) {
    import(/* webpackChunkName: "semi-delivery-list" */ './components/Semi/Delivery/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the SEMI Delivery app!', error));
}
if (document.getElementById('semi-invoice-list')) {
    import(/* webpackChunkName: "semi-invoice-list" */ './components/Semi/Invoice/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the SEMI Invoice app!', error));
}
if (document.getElementById('semi-credit-debit-list')) {
    import(/* webpackChunkName: "semi-credit-debit-list" */ './components/Semi/CreditDebit/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the SEMI Credit/Debit app!', error));
}
if (document.getElementById('service-list')) {
    import(/* webpackChunkName: "service-list" */ './components/ServiceList/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app ServiceList!', error));
}
if (document.getElementById('session-timeout-popup')) {
    import(/* webpackChunkName: "session-timeout-popup" */ './components/SessionTimeoutPopup/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app SessionTimeoutPopup!', error));
}
if (document.getElementById('delivery-price-check')) {
    import('./components/DeliveryPriceCheck/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app Delivery Price Check!', error));
}

if (document.getElementById('generic-request')) {
    import(/* webpackChunkName: "generic-request" */ './components/GenericRequest/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the GenericRequest!', error));
}

if (document.querySelector('[data-special-binning]')) {
    import(/* webpackChunkName: "special-binning" */ './components/SpecialBinning/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading Special Binning!', error));
}

// Load GSAP only if there are fragments that want to animate (data-animate-root)
if (document.querySelector('[data-animate-root]')) {
    import(/* webpackChunkName: "gsap" */ 'gsap')
        .then(gsapModule => {
            try {
                window.gsap = gsapModule && gsapModule.gsap ? gsapModule.gsap : gsapModule.default || gsapModule;
            } catch {
                window.gsap = gsapModule.default || gsapModule;
            }

            var evt = new Event('gsap:loaded');
            window.dispatchEvent(evt);
        })
        .catch(error => console.warn('Failed to load gsap via webpack import', error));
}

if (document.getElementById('invoice-list')) {
    import(/* webpackChunkName: "invoice-list" */ './components/Invoice/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app Invoice!', error));
}

if (document.getElementById('mail-report-list')) {
    import(/* webpackChunkName: "mail-report-list" */ './components/MailReport/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app MailReport!', error));
}

if (document.getElementById('design-system-showcase')) {
    import(/* webpackChunkName: "design-system-showcase" */ './components/DesignSystem/Showcase/index.js')
        .then(module => {
            if (module && module.default) module.default();
        })
        .catch(error => console.error('An error occurred while loading the Design System Showcase!', error));
}

if (document.getElementById('my-account')) {
    import('./components/MyAccount/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app My account!', error));
}

if (document.getElementById('credit-list')) {
    import(/* webpackChunkName: "credit-list" */ './components/Credit/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app Credit!', error));
}

if (document.getElementById('debit-list')) {
    import(/* webpackChunkName: "debit-list" */ './components/Debit/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app Debit!', error));
}

if (document.getElementById('order-list')) {
    import('./components/Order/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app Order list!', error));
}

if (document.getElementById('carts-list')) {
    import(/* webpackChunkName: "carts-list" */ './components/Carts/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the CartsList module!', error));
}

if (document.getElementById('price-list')) {
    import('./components/PriceList/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app Price list!', error));
}

if (document.querySelector('a[data-gated-content]')) {
    import(/* webpackChunkName: "gated-content" */ './legacy/convert-gated-content-links.js')
        .then(module => module.default())
        .catch(error =>
            console.error('An error occurred while trying to load the gated content link conversion module.', error)
        );
}

if (document.querySelector('[data-request-document-download]')) {
    import(/* webpackChunkName: "gated-content" */ './legacy/request-document-download.js')
        .then(module => module.default())
        .catch(error =>
            console.error(
                'An error occurred while trying to load the document download event dispatcher module.',
                error
            )
        );
}

if (document.getElementById('app-document-download-approval')) {
    import(/* webpackChunkName: "gated-content" */ './legacy/document-download-approval/index.js')
        .then(module => module.default())
        .catch(error =>
            console.error('An error occurred while trying to load the document download approval module.', error)
        );
}

if (document.getElementById('app-gated-content-form')) {
    import(/* webpackChunkName: "gated-content" */ './legacy/gated-content/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occurred while trying to load the gated content module.', error));
}

/** This snippet loads legacy styles for old ams.com components if they are detected on the page. */
if (
    document.querySelector(
        '.journal-content-article .banner, .journal-content-article .blog-entry, .g-edit-button, .portlet-asset-publisher .cards--no-padding > .container > .cards__content.row, .portlet-asset-publisher .cards .cards__content.row, .microsite-banner, .ms-cards, .journal-content-article .ms-newsletter, .journal-content-article .info-detail, #news-hub-container, .newsletter-form, div[id^="fragment-"] > .product, .st-article, .journal-content-article .tcc, body[class*="page-about-usinvestor-relations"]'
    )
) {
    import(/* webpackChunkName: "legacy" */ '../scss/legacy.scss').catch(error =>
        console.error('Could not load legacy styles!', error)
    );
}

if (document.querySelector('.sub-navigation')) {
    import(/* webpackChunkName: "slider" */ './components/sub-navigation.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Sub Navigation script!`', error));
}

if (document.getElementById('app-cart')) {
    import(/* webpackChunkName: "shop" */ './components/Shop/Cart/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the cart 🛒 module!`', error));
}
if (document.getElementById('app-ecom-cart')) {
    import(/* webpackChunkName: "shop" */ './components/Shop/Cart/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the cart 🛒 module!`', error));
}
if (document.getElementById('quick-order-cart')) {
    import(/* webpackChunkName: "shop" */ './components/Shop/QuickOrder/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Quick order module!`', error));
}
if (document.getElementById('app-my-orders')) {
    import(/* webpackChunkName: "myOrders" */ './components/Shop/MyOrders/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the myOrders module!`', error));
}
if (document.getElementById('app-my-registration-projects')) {
    import(/* webpackChunkName: "myRegistrationProjects" */ './components/Semi/MyRegistrationProjects/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occurred while loading the my registration projects module!', error));
}

if (document.getElementById('build-info')) {
    import(/* webpackChunkName: "buildinfo" */ './components/BuildInfo/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the buildinfo module!`', error));
}

if (document.querySelector('.product-hero')) {
    import(/* webpackChunkName: "product-hero" */ './components/favorites.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the component `Favorites`!', error));
}

if (document.querySelector('.attention')) {
    import(/* webpackChunkName: "product-hero" */ './components/product-actions.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the component `Product hero`!', error));
}

if (document.querySelector('.product-hero.has-datasheets')) {
    import(/* webpackChunkName: "product-hero" */ './components/datasheets-popup.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the component `Datasheets Popup`!', error));
}

if (document.getElementById('app-favorite')) {
    import(/* webpackChunkName: "favorite-list" */ './components/FavoriteList/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app FavoriteList!', error));
}

if (document.getElementById('ai-search')) {
    import(/* webpackChunkName: "ai-search" */ './components/AiSearch/index')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the AI Search', error));
}

if (document.querySelector('.slider-content')) {
    import(/* webpackChunkName: "slider-content" */ './components/sliderContent.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the component `SliderContent`!', error));
}
if (
    document.querySelector(
        '.card-background-video-desktop, .card-background-video-tablet, .card-background-video-mobile,.slider-hero-background-video-desktop,.slider-hero-background-video-mobile,.slider-hero-background-video-tablet'
    )
) {
    import(/* webpackChunkName: "video" */ './components/background-video.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Background-Video fragment script!`', error));
}
if (document.getElementById('dangerous-goods-download')) {
    import(/* webpackChunkName: "dangerous-goods" */ './components/dangerous-goods-download.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Dangerous goods script!`', error));
}
window.addEventListener('load', function () {
    import(/* webpackChunkName: "header-tooltip" */ './components/header-tooltip.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Header-Tooltip fragment script!`', error));
});

// Platform-wide security-classification acknowledgment dialog + global click guard.
import(/* webpackChunkName: "security-class-dialog" */ './components/SecurityClassDialog/index.js')
    .then(module => {
        module.default();
    })
    .catch(error => console.error('An error occurred while loading the Security Class Dialog!`', error));

if (document.getElementById('app-product-ordering-codes')) {
    import(/* webpackChunkName: "ProductOrderingCodes" */ './components/ProductOrderingCodes/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the ProductOrderingCodes module!`', error));
}

if (document.getElementById('app-product-download')) {
    import(/* webpackChunkName: "product-download" */ './components/ProductDownload/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the ProductDownload module!`', error));
}

if (document.getElementById('product-selection')) {
    import(/* webpackChunkName: "product-selector" */ './components/ProductSelector/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the ProductSelection module!`', error));
}

if (document.getElementById('product-packaging')) {
    import('./components/product-packaging.js')
        .then(module => {
            module.default();
        })
        .catch(error =>
            console.error('An error occurred while loading the Product packaging fragment script!`', error)
        );
}

if (document.getElementById('account-statement')) {
    import(/* webpackChunkName: "account-statement" */ './components/AccountStatement/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the AccountStatement module!`', error));
}

if (document.getElementById('user-profile')) {
    import(/* webpackChunkName: "user-profile" */ './components/UserProfile/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the UserProfile module!`', error));
}

if (document.getElementById('category-hierarchy')) {
    import(/* webpackChunkName: "category-hierarchy" */ './components/CategoryHierarchy/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the CategoryHierarchy module!`', error));
}
if (document.getElementById('my-personalized-reports')) {
    import('./components/MyPersonalizedReports/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the MyPersonalizedReports module!`', error));
}
if (document.getElementById('app-icons-list')) {
    import(/* webpackChunkName: "icons-list" */ './components/IconsList/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the IconsList module!', error));
}

if (document.querySelector('[data-global-popup-id]')) {
    import('./components/GlobalPopup/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Global popup module!`', error));
}
if (document.querySelector('#cart-detail')) {
    import('./components/Cart/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Cart module!', error));
}

if (document.querySelector('[data-account-selector-menu]')) {
    document.querySelectorAll('[data-account-selector-menu]').forEach(menu => {
        import('./components/AccountSelector/index.js')
            .then(module => {
                module.default(menu);
            })
            .catch(error => console.error('An error occurred while loading the AccountSelector module!', error));
    });
}

if (document.querySelector('#language-selector-menu')) {
    import('./components/LanguageSelector/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => {
            console.error('An error occurred while loading the LanguageSelector module!', error);
        });
}

if (document.querySelector('#impersonate-button')) {
    import('./components/Impersonate/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => {
            console.error('An error occurred while loading the ImpersonateCmp module!', error);
        });
}

if (process.env.NODE_ENV !== 'production') {
    window.Liferay.Icons.controlPanelSpritemap = '/o/admin-theme/images/clay/icons.svg';
    window.Liferay.Icons.spritemap = '/o/ams-osram-theme/images/clay/icons.svg';
    const portalUrl = `${window.Liferay.ThemeDisplay.getPortalURL()}/`;

    const anchors = document.querySelectorAll(`a[href^="${portalUrl}"]`);
    anchors?.forEach(a => {
        a.href = a.href.replace(portalUrl, '/');
    });

    const forms = document.querySelectorAll(`form[action^="${portalUrl}"]`);
    forms?.forEach(f => {
        f.action = f.action.replace(portalUrl, '/');
    });

    const svgUses = document.querySelectorAll(`use`);
    svgUses?.forEach(use => {
        const href = use.getAttribute('xlink:href') || use.getAttribute('href');
        if (href && href.startsWith(portalUrl)) {
            use.setAttribute('xlink:href', href.replace(portalUrl, '/'));
            use.setAttribute('href', href.replace(portalUrl, '/'));
        }
    });
}

// Remove user menu built-in tooltip
const defaultUserIcon = document.querySelector('.js-user-menu span.icon');
if (defaultUserIcon) {
    defaultUserIcon.removeAttribute('title');
}

// Handle impersonated links
const isImpersonating = window.themeDisplay.isImpersonated();
if (isImpersonating) {
    const impersonatedId = window.themeDisplay.getDoAsUserIdEncoded();
    document.querySelectorAll('a[href]').forEach(link => {
        import('./common/utils/processImpersonateLinks')
            .then(module => {
                module.processImpersonateLinks(link, impersonatedId);
            })
            .catch(console.error);
    });
}

const ACCOUNT_ROLES_SELECTOR = '[data-component="account-roles"]';
const MODAL_IFRAME_SELECTOR = '#modalIframe';

const IS_ECOM = window.ams?.isEcomSite || false;
const IS_SEMI = window.ams?.isEcomSemi || false;

// Prevent attaching multiple load listeners to the same iframe.
const observedIframes = new WeakSet();

function initializeIframe(iframe) {
    if (!iframe || observedIframes.has(iframe)) {
        return;
    }

    observedIframes.add(iframe);

    const initializeAccountRoles = () => {
        try {
            const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;

            if (!iframeDocument) {
                return;
            }

            const accountRolesElements = iframeDocument.querySelectorAll(ACCOUNT_ROLES_SELECTOR);

            if (!accountRolesElements.length) {
                console.log('Account roles component not found inside iframe.');

                return;
            }

            let init = null;
            if (IS_SEMI && IS_ECOM) {
                init = initSemiAccountRoles;
            } else if (!IS_SEMI && IS_ECOM) {
                init = initAmspAccountRoles;
            } else {
                init = null;
            }

            accountRolesElements.forEach(element => {
                if (element.dataset.permissionMonitorInitialized === 'true') {
                    return;
                }

                element.dataset.permissionMonitorInitialized = 'true';

                console.log('Initializing account roles:', element);

                init(element);
            });
        } catch (error) {
            console.error('An error occurred while initializing PermissionMonitor!', error);
        }
    };

    iframe.addEventListener('load', initializeAccountRoles, { once: true });

    // Handle the case where the iframe loaded before detection.
    if (iframe.contentDocument?.readyState === 'interactive' || iframe.contentDocument?.readyState === 'complete') {
        initializeAccountRoles();
    }
}

function findAccountRolesIframes() {
    document.querySelectorAll(MODAL_IFRAME_SELECTOR).forEach(initializeIframe);
}

// Handle an iframe that may already exist.
findAccountRolesIframes();

// Detect iframe creation whenever the modal is opened.
const accountRolesObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
            if (!(node instanceof HTMLElement)) {
                return;
            }

            if (node.matches(MODAL_IFRAME_SELECTOR)) {
                initializeIframe(node);

                return;
            }

            node.querySelectorAll(MODAL_IFRAME_SELECTOR).forEach(initializeIframe);
        });
    });
});

accountRolesObserver.observe(document.body, {
    childList: true,
    subtree: true,
});

window.addEventListener('amsOsramPermissionMonitorAssignRolesTitle', event => {
    const modalTitle = document.querySelector('.modal-title');
    if (modalTitle) {
        modalTitle.textContent = `Assign Roles - ${event.detail.titleText}`;
    }
});
